import {
  Currency,
  currencySymbols,
  CampaignType,
  campaigns,
  toCurrency,
  User,
  pluralise,
} from "@ecologi/shared";
import {
  getDonationImpactMapper,
  donationImpactMapperLapland,
  DonationType,
} from "../consts/donation-options";

const treeNames = [
  "clump",
  "thicket",
  "spinney",
  "grove",
  "woodland",
  "forest",
  "biome",
  "world",
];

export const getDonationOptions = (
  donationTypeId: DonationType,
  currency: Currency,
  campaign?: CampaignType | null,
  user?: User | null,
  isOwnProfile?: boolean
) => {
  const isIntrepid = campaign === campaigns.intrepid.id;
  const isLapland = campaign === campaigns.lapland.id;
  const donationOptions = isLapland
    ? donationImpactMapperLapland
    : getDonationImpactMapper(user, isOwnProfile);

  const donationsForCurrency = donationOptions[donationTypeId]![currency];

  return Object.keys(donationsForCurrency)
    .map((cost, idx) => {
      const { numberOfTrees, numberOfTonnes } = donationsForCurrency[cost];
      const trees = numberOfTrees
        ? `A ${treeNames[idx]} of ${numberOfTrees.toString()} trees `
        : "";

      // bespoke: Intrepid match donations so we add this label in
      const intrepidTrees =
        isIntrepid && numberOfTrees
          ? `+ ${numberOfTrees.toString()} trees matched from Intrepid `
          : "";

      const both = numberOfTrees && numberOfTonnes ? "+ " : "";
      const offsets = numberOfTonnes
        ? `${pluralise(numberOfTonnes, "tonne")} CO2e avoided `
        : "";

      return {
        value: cost.toString(),
        label: `${trees}${intrepidTrees}${both}${offsets}- ${
          currencySymbols[currency]
        }${toCurrency(parseInt(cost) / 100)}`,
      };
    })
    .sort((a, b) => (Number(a.value) > Number(b.value) ? 1 : -1));
};
